import { createFileRoute } from "@tanstack/react-router";
import { canonical } from "@/components/site/site-config";
import { CityPageBody } from "@/components/site/CityPageBody";
import { BUSINESS } from "@/components/site/constants";

export const Route = createFileRoute("/roofing-company-spring-hill-fl")({
  head: () => ({
    meta: [
      { title: "Roofing Company in Spring Hill, FL | Destination Roofing" },
      { name: "description", content: `Roof repair and roof replacement in Spring Hill, FL. Family-owned, licensed and insured. Free Roof Inspection & Estimate. ${BUSINESS.phone}.` },
      { property: "og:title", content: "Roofing Company in Spring Hill, FL" },
      { property: "og:description", content: "Local roofer serving Spring Hill, FL. Free Roof Inspection & Estimate." },
      { property: "og:url", content: canonical("/roofing-company-spring-hill-fl") },
    ],
    links: [{ rel: "canonical", href: canonical("/roofing-company-spring-hill-fl") }],
  }),
  component: () => (
    <CityPageBody
      city="Spring Hill"
      intro={
        <p>
          Spring Hill is a large community with tens of thousands of single-family homes, most built between the 1970s and the early 2000s. That means a huge chunk of Spring Hill roofs are on their second — or in some cases third — cycle.
        </p>
      }
      localNotes={
        <>
          <p>
            The most common calls we get in Spring Hill are for aging shingle roofs at end of life, roof leak repair around plumbing vents and skylights, and storm damage after summer thunderstorms. On homes still on their original roof from the 90s, a full replacement is almost always the smart move.
          </p>
          <p>
            Because so many Spring Hill homes look similar from the street, a new roof — especially a good architectural shingle in the right color — is one of the biggest curb-appeal upgrades you can make.
          </p>
        </>
      }
    />
  ),
});
